/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const browsePages = {
    ChartsHubPage: () => import('@/browse/ChartsHubPage'),
    CuratedTopicPage: () => import('@/curated/CuratedTopicPage'),
    fixedTitleSeeAll: () => import('@/seeAll/fixedTitleSeeAll'),
    GenreDetailPage: () => import('@/genre/GenreDetailPage'),
    NewReleasesPage: () => import('@/newReleases/NewReleasesPage'),
    PlaylistsHubPage: () => import('@/browse/PlaylistsHubPage'),
    SeeAllPage: () => import('@/seeAll/SeeAllPage'),
}
